// UTM parameter tracking utilities

// Get UTM parameters from URL
export const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    source: params.get('utm_source'),
    medium: params.get('utm_medium'),
    campaign: params.get('utm_campaign'),
    term: params.get('utm_term'),
    content: params.get('utm_content'),
    gclid: params.get('gclid'), // Google Ads Click ID
    fbclid: params.get('fbclid'), // Facebook Click ID
    msclkid: params.get('msclkid'), // Microsoft/Bing Click ID
    ttclid: params.get('ttclid') // TikTok Click ID
  };
};

// Store UTM params in session storage
export const storeUTMParams = () => {
  const params = getUTMParams();
  
  // Only store if we have at least one UTM parameter
  if (Object.values(params).some(value => value !== null)) {
    sessionStorage.setItem('utm_params', JSON.stringify(params));
    
    // Store first touch if not already stored
    if (!localStorage.getItem('first_touch_utm')) {
      localStorage.setItem('first_touch_utm', JSON.stringify({
        ...params,
        timestamp: new Date().toISOString(),
        landingPage: window.location.pathname
      }));
    }
    
    // Always update last touch
    sessionStorage.setItem('last_touch_utm', JSON.stringify({
      ...params,
      timestamp: new Date().toISOString(),
      landingPage: window.location.pathname
    }));
  }
};

// Get first touch attribution
export const getFirstTouch = () => {
  const stored = localStorage.getItem('first_touch_utm');
  return stored ? JSON.parse(stored) : null;
};

// Get last touch attribution
export const getLastTouch = () => {
  const stored = sessionStorage.getItem('last_touch_utm');
  return stored ? JSON.parse(stored) : null;
};

// Get current session UTM params
export const getCurrentUTM = () => {
  const stored = sessionStorage.getItem('utm_params');
  return stored ? JSON.parse(stored) : null;
};

// Store click IDs in cookies for later use
export const storeClickIDs = () => {
  const params = getUTMParams();
  
  // Store click IDs with 30-day expiration
  const expires = new Date();
  expires.setDate(expires.getDate() + 30);
  
  if (params.gclid) {
    document.cookie = `gclid=${params.gclid}; expires=${expires.toUTCString()}; path=/`;
  }
  if (params.fbclid) {
    document.cookie = `fbclid=${params.fbclid}; expires=${expires.toUTCString()}; path=/`;
  }
  if (params.msclkid) {
    document.cookie = `msclkid=${params.msclkid}; expires=${expires.toUTCString()}; path=/`;
  }
  if (params.ttclid) {
    document.cookie = `ttclid=${params.ttclid}; expires=${expires.toUTCString()}; path=/`;
  }
};

// Get click ID from cookie
export const getClickID = (platform) => {
  const name = `${platform}clid=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
};

// Initialize UTM tracking on page load
export const initializeUTMTracking = () => {
  storeUTMParams();
  storeClickIDs();
};

export default {
  getUTMParams,
  storeUTMParams,
  getFirstTouch,
  getLastTouch,
  getCurrentUTM,
  storeClickIDs,
  getClickID,
  initializeUTMTracking
};